import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../../store';
import { get, post, put } from '../../../inteceptor';
import moment from 'moment';

const initialState = {
  error: null,
  time: null,
  data: [],
  addData: {},
  sorted: [],
};

const slice = createSlice({
  name: 'TimeLog',
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.error = { message: action.payload, time: moment.now().toString() };
    },

    // GET TimeLogManagement
    getTimeLogsSuccess(state, action) {
      state.data = action.payload.data;
    },

    addOrUpdateTimeLogs(state, action) {
      state.addData = {
        data: action.payload.data,
        time: moment.now().toString(),
      };
    },

    clearAll(state) {
      state.addData = {};
      state.error = {};
    },

    onBackStep(state) {
      state.checkout.activeStep -= 1;
    },

    onNextStep(state) {
      state.checkout.activeStep += 1;
    },

    onGotoStep(state, action) {
      const goToStep = action.payload;
      state.checkout.activeStep = goToStep;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { filterCategories } = slice.actions;

// ----------------------------------------------------------------------

export function getTimeLogs(startDate, endDate) {
  return async () => {
    try {
      const response = await get(`timeLog?startDate=${startDate}&endDate=${endDate}`);
      if (response.status) {
        dispatch(slice.actions.getTimeLogsSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function addTimeLog(body) {
  return async () => {
    try {
      const response = await post(`timeLog`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateTimeLogs(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function updateTimeLog(body) {
  return async () => {
    try {
      const response = await put(`timeLog`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateTimeLogs(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
